<template>
    <span class="label label-info">
        <i class="fa fa-book" aria-hidden="true"></i> {{ question.bookReference }}
    </span>
</template>

<script>
    export default {
        props: ['question']
    };
</script>